import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from '@ghostscreen/contracts';
import { englishResources, NAMESPACES } from './resources';

/**
 * The app-wide i18next instance. Starts in English synchronously (English is
 * bundled), so tests and first paint never wait; other languages are loaded
 * on demand by `applyLocale`.
 */
void i18n.use(initReactI18next).init({
  resources: { [DEFAULT_LOCALE]: englishResources },
  partialBundledLanguages: true,
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  supportedLngs: [...SUPPORTED_LOCALES],
  nonExplicitSupportedLngs: true,
  load: 'languageOnly',
  ns: NAMESPACES,
  defaultNS: 'common',
  initAsync: false,
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export { i18n };
